export default class User {
  id;
  email;
  displayName;
  photoURL;
  customClaims;
  userLocations;
  stripeCustomerId;

  constructor(
    id,
    email,
    displayName,
    photoURL,
    customClaims,
    userLocations,
    stripeCustomerId
  ) {
    this.id = id;
    this.email = email;
    this.displayName = displayName;
    this.photoURL = photoURL;
    this.customClaims = customClaims;
    this.userLocations = userLocations;
    this.stripeCustomerId = stripeCustomerId;
  }

  static firebaseConverter = {
    fromFirestore(snapshot, options) {
      let id = snapshot.id;
      const data = { id, ...snapshot.data(options) };

      return new User(
        data.id,
        data.email,
        data.displayName,
        data.photoURL,
        data.customClaims,
        data.userLocations,
        data.stripeCustomerId
      );
    },

    toFirestore(user) {
      let {
        id,
        email,
        displayName,
        photoURL,
        customClaims,
        userLocations,
        stripeCustomerId
      } = user;
      return {
        id,
        email,
        displayName,
        photoURL,
        customClaims,
        userLocations,
        stripeCustomerId
      };
    }
  };
}
